import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zhTW from './locales/zh-TW.json'
import zhCN from './locales/zh-CN.json'
import jaJP from './locales/ja-JP.json'
import {getBrowserLanguage} from './detector'

// 1. Priority: LocalStorage -> Browser Detection -> Hardcoded Default ('en')
const defaultLocale = localStorage.getItem('lang') || getBrowserLanguage() || 'en'

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'ja-JP': jaJP,
  }
})

import { setI18nMenu } from '@myorg/menu-editor-lib'
setI18nMenu((key: string) => i18n.global.t(key))

import { setI18n } from '@myorg/type-lib'
setI18n((key: string) => i18n.global.t(key))


export default i18n
